import { isElectron } from "@/config/electron";
import { useLocalStorage, type UseStorageOptions } from "@vueuse/core";
import { ref, type Ref } from "vue";

/**
 * Creates a state ref value. On Electron, always uses localStorage so that
 * sub-windows can read state. On web, uses a plain ref since there are no
 * sub-windows and localStorage would interfere with multiple browser tabs.
 *
 * @param key string to store the state to in localstorage
 * @param initialValue
 * @returns
 */
export function useRefOrLocalStorage<T>(key: string, initialValue: T, options?: UseStorageOptions<T>): Ref<T> {
    if (isElectron()) {
        return useLocalStorage<T>(key, initialValue, options);
    } else {
        return ref<T>(initialValue) as Ref<T>;
    }
}
